
// src/reducers/chat-messages-reducer.js

import { 
  FETCH_CHAT_MESSAGES,
  FETCH_CHAT_MESSAGES_REQUESTED,
  FETCH_CHAT_MESSAGES_COMPLETED,
  FETCH_CHAT_MESSAGES_FAILED,
  POST_CHAT_MESSAGE,
  POST_CHAT_MESSAGE_REQUESTED,
  POST_CHAT_MESSAGE_COMPLETED,
  POST_CHAT_MESSAGE_FAILED,
  DELETE_CHAT_MESSAGE,
  DELETE_CHAT_MESSAGE_REQUESTED,
  DELETE_CHAT_MESSAGE_COMPLETED,
  DELETE_CHAT_MESSAGE_FAILED,
  CLEAR_CHAT_MESSAGES,
  LOAD_CHAT_MESSAGE,
  REMOVE_CHAT_MESSAGE,
} from '../actions/chat-messages'

import {
  TRANSLATE_MESSAGE_COMPLETED
} from '../actions/translate'

import { mergeArray, getArray, deleteArray, updateArray } from '../helpers/store'

import { REACT_CHAT_COMPLETED, DELETE_REACT_CHAT_COMPLETED } from '../actions/react-chat'

const initialState = {
  isRequesting: false,
}

export default function chatMessagesReducer(state = initialState, action = {}) {
  let item
  switch(action.type) {
  case FETCH_CHAT_MESSAGES_REQUESTED:
    item = Object.assign({}, state[action.chat_room_id] || {}, {
      isFetching: true,
      isFetchFailed: false,
      hasMore: true,
    })
    return Object.assign({}, state, { [action.chat_room_id]: item })

  case POST_CHAT_MESSAGE_REQUESTED:
    item = Object.assign({}, state[action.chat_room_id] || {}, {
      isPosting: true,
      isPostFailed: false,
      withFiles: action.withFiles,
    })
    return Object.assign({}, state, { [action.chat_room_id]: item })

  case DELETE_CHAT_MESSAGE_REQUESTED:
    return Object.assign({}, state, {
      isRequesting: true,
    })

  case POST_CHAT_MESSAGE_FAILED:
    item = Object.assign({}, state[action.chat_room_id] || {}, {
      isPosting: false,
      isPostFailed: true,
    })
    return Object.assign({}, state, { [action.chat_room_id]: item })

  case DELETE_CHAT_MESSAGE_FAILED:
    return Object.assign({}, state, {
      isRequesting: false,
    })

  case FETCH_CHAT_MESSAGES_FAILED:
    item = Object.assign({}, state[action.chat_room_id] || {}, {
      isFetching: false,
      isFetchFailed: true,
    })
    return Object.assign({}, state, { [action.chat_room_id]: item })

  case FETCH_CHAT_MESSAGES_COMPLETED:
  case REACT_CHAT_COMPLETED:
  case DELETE_REACT_CHAT_COMPLETED:
    item = state[action.chat_room_id] || {}
    item = Object.assign({}, state[action.chat_room_id] || {}, {
      isFetching: false,
      hasMore: action.results.length == 10,
      items: action.offset > 0 ? mergeArray('message_id', item.items, action.results) : action.results,
    })
    return Object.assign({}, state, { [action.chat_room_id]: item })

  case POST_CHAT_MESSAGE_COMPLETED:
    item = state[action.chat_room_id] || {}
    item = Object.assign({}, item, {
      isPosting: false,
      items: mergeArray('message_id', item.items, [action.results], 'replace_or_prepend'),
    })
    return Object.assign({}, state, { [action.chat_room_id]: item })

  case DELETE_CHAT_MESSAGE_COMPLETED:
    item = state[action.chat_room_id] || {}
    item = Object.assign({}, item, {
      isRequesting: false,
      items: deleteArray('message_id', item.items, [action.results.message_id])
    })
    return Object.assign({}, state, { [action.chat_room_id]: item })

  case CLEAR_CHAT_MESSAGES:
    return initialState

  case LOAD_CHAT_MESSAGE:
    item = state[action.chat.chat_room_id]
    if (!item) return state  // chat_room_idのデータがからの場合は何もしない

    const current_message = getArray('message_id', item.items, action.chat.message_id)
    if ((current_message && current_message.readers && current_message.readers.length || 0) > (action.chat.readers && action.chat.readers.length || 0))
      return state // 受け取ったmessageのreadersの数が、現在storeに入っているものより少ない場合は、データが先祖返りしているため破棄する

    if (action.appending || (item.items && item.items.find((i)=> i.message_id == action.chat.message_id))) {
      item = Object.assign({}, item, {
        // action.appendingがtrueの場合は末尾に追加・さもなくば破棄
        items: mergeArray('message_id', item.items, [action.chat], action.appending ? 'replace_or_prepend' : 'discard')
      })
      return Object.assign({}, state, { [action.chat.chat_room_id]: item })
    } else
      return state

  case REMOVE_CHAT_MESSAGE:
    item = state[action.chat_room_id]
    if (!item) return state  // chat_room_idのデータがからの場合は何もしない
    item = Object.assign({}, item, {
      isRequesting: false,
      items: deleteArray('message_id', item.items, [action.message_id])
    })
    return Object.assign({}, state, { [action.chat_room_id]: item })

  case TRANSLATE_MESSAGE_COMPLETED:
    item = state[action.chat_room_id]
    if (!item) return state  // chat_room_idのデータがからの場合は何もしない
    item = Object.assign({}, item, {
      items: updateArray('message_id', item.items, action.message_id, 'attach_json', action.result.attach_json)
    })
    return Object.assign({}, state, { [action.chat_room_id]: item })

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/chat-messages-reducer.js